<template>
  <v-container :class="busy ? 'fill-height' : ''" id="top-up-redirect">
    <v-row v-if="busy">
      <v-col class="text-center">
        <v-progress-circular
          :size="150"
          :width="6"
          class="mb-4"
          color="primary"
          indeterminate
        ></v-progress-circular>
        <div class="display-1">Uw bestelling wordt verwerkt.</div>
      </v-col>
    </v-row>

    <v-row v-else justify="center">
      <v-col class="mt-12">
        <MaterialCardV2
          :icon="getCardIcon"
          color="primary"
          :title="getCardTitle"
        >
          <v-row class="pa-5" align="center">
            <v-col v-if="topUpResult.external_payment_state === 'paid'">
              <v-row>
                <v-col class="font-weight-regular">Door u betaald:</v-col>
                <v-col>
                  {{ (topUpResult.amount / 100) | currency }}
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col class="font-weight-regular">Door u ontvangen:</v-col>
                <v-col
                  >{{
                    ((topUpResult.bonus + topUpResult.amount) / 100) | currency
                  }}
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col class="font-weight-regular">Uw nieuwe saldo:</v-col>
                <v-col>
                  {{ (topUpResult.balance_after / 100) | currency }}
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </v-col>
            <v-col v-else>
              <div class="display-1">
                Is er geld van uw rekening afgeschreven, maar is uw prepaid
                saldo is niet opgehoogd?<br />
                Neem in dat geval contact op met onze <a>klanten service.</a>
              </div>
            </v-col>
            <v-col align="center" class="hidden-sm-and-down" cols="6">
              <v-icon size="100">{{ getCardIcon }}</v-icon>
            </v-col>
          </v-row>

          <v-divider class="mt-6"></v-divider>
          <v-row>
            <v-col>
              <v-btn
                class="no-text-transform display-1"
                color="grey darken-3"
                text
                :to="{ name: $store.state.config.main_page }"
                >Keer terug naar de hoofdpagina
                <v-icon class="ml-2 lighten-5 " small>mdi-home</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </MaterialCardV2>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MaterialCardV2 from "@/components/views/MaterialCardV2";

export default {
  name: "TopUpRedirect",
  components: { MaterialCardV2 },
  mounted() {
    if (!this.$store.state.topup.payment_id) {
      this.$router.push({ name: this.$store.state.config.main_page });
    } else {
      setTimeout(() => {
        this.$store
          .dispatch("topup/topUpResult")
          .then(response => {
            this.topUpResult = response.data;
            this.$store.commit("user/user", {
              balance: this.topUpResult.balance_after
            });
          })
          .finally(() => {
            this.busy = false;
          });
      }, 10000);
    }
  },
  data() {
    return {
      topUpResult: {},
      busy: true
    };
  },
  computed: {
    getCardIcon() {
      return this.topUpResult.external_payment_state === "paid"
        ? "mdi-check"
        : "mdi-alert-circle-outline";
    },
    getCardTitle() {
      return this.topUpResult.external_payment_state === "paid"
        ? "Uw bestelling is succesvol afgerond!"
        : "Uw bestelling is afgerond met een foutmelding.";
    }
  }
};
</script>

<style scoped></style>
